module.exports = __webpack_public_path__ + "img/cmc_2.96a7bbd3.png";